import React, { useContext } from "react";

const Pesquisar = ({ children, context }) => {
  const { searchHandler } = useContext(context);

  return (
    <div className="row">
      <div className="col-12">
        <div className="default-title">Pesquisa</div>
        <div className="card shadow-sm mb-4">
          <div className="row align-items-end">
            {children}
            <div className="col-auto ">
              <button
                type="button"
                className="btn btn-success"
                onClick={searchHandler}
              >
                Buscar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pesquisar;
